import { debounce } from 'ts-debounce';

export default debounce;
